export default __webpack_public_path__ + "static/media/mirrorcle-world-ayumi-hamasaki.6a4a23a7.jpg";